import { RouteRecordRaw } from 'vue-router';

import i18n from '../i18n/i18n';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: 'usage',
    },
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => import('../views/UsageView.vue'),
    meta: {
      requiresAuth: true,
      title: i18n.global.t('sidebar.Usage'),
    },
  },
  {
    path: '/environments',
    name: 'environments',
    component: () => import('../views/EnvironmentsView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'environments.view',
      title: i18n.global.t('sidebar.Environments'),
    },
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('../views/AccountsView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'accounts.view',
      title: i18n.global.t('sidebar.Accounts'),
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: {
      name: 'root',
    },
  },
];

export default routes;
